module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "ProfileViewing"
  }, [_c('div', {
    staticClass: "form-group col-md-5"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-default form-group",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "ProfileEditing col-md-5"
  }, [(_vm.org['curOrg']['role'] == '1' || _vm.org['curOrg']['role'] == 99) ? _c('div', [_c('form-text', {
    ref: "name",
    attrs: {
      "styler": "font-size:35px",
      "label": "Name",
      "name": "name",
      "validation": "required"
    },
    model: {
      value: (_vm.userEdit.displayName),
      callback: function($$v) {
        _vm.$set(_vm.userEdit, "displayName", $$v)
      },
      expression: "userEdit.displayName"
    }
  })], 1) : _c('div', [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _c('form-text', {
    ref: "email",
    attrs: {
      "label": "Email",
      "name": "email",
      "validation": "required|email"
    },
    model: {
      value: (_vm.userEdit.email),
      callback: function($$v) {
        _vm.$set(_vm.userEdit, "email", $$v)
      },
      expression: "userEdit.email"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn  btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_vm._v("Submit")])])], 1), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "role": "tabcard",
      "id": "tab-orgs"
    }
  }, [_c('data-table', {
    attrs: {
      "data": _vm.orgs,
      "columns": _vm.columns,
      "filter-key": _vm.searchQuery
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabcard",
      "id": "tab-notificationtriggers"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.triggers.emailnotif),
      expression: "triggers.emailnotif"
    }],
    attrs: {
      "type": "checkbox",
      "id": "emailnotif",
      "name": "emailnotif"
    },
    domProps: {
      "checked": Array.isArray(_vm.triggers.emailnotif) ? _vm._i(_vm.triggers.emailnotif, null) > -1 : (_vm.triggers.emailnotif)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.triggers.emailnotif,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.triggers, "emailnotif", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.triggers, "emailnotif", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.triggers, "emailnotif", $$c)
        }
      }, _vm.updateTriggers]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("   Late Workflow Emails")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabcard",
      "id": "tab-pwdreset"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.has('pwdold')
    }
  }, [_c('div', {
    staticClass: "has-float-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd.old),
      expression: "pwd.old"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "pwdold",
      "name": "pwdold",
      "placeholder": "Old Password"
    },
    domProps: {
      "value": (_vm.pwd.old)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pwd, "old", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'pwdold'
    }
  }, [_vm._v("Old Password")]), _vm._v(" "), (_vm.errors.has('pwdold')) ? _c('div', {
    staticClass: "form-control-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('pwdold')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.has('pwdnew')
    }
  }, [_c('div', {
    staticClass: "has-float-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd.new),
      expression: "pwd.new"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "pwdnew",
      "name": "pwdnew",
      "placeholder": "New Password"
    },
    domProps: {
      "value": (_vm.pwd.new)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pwd, "new", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'pwdnew'
    }
  }, [_vm._v("New Password")]), _vm._v(" "), (_vm.errors.has('pwdnew')) ? _c('div', {
    staticClass: "form-control-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('pwdnew')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.has('pwdnewverify')
    }
  }, [_c('div', {
    staticClass: "has-float-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd.newverify),
      expression: "pwd.newverify"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:pwdnew'),
      expression: "'required|confirmed:pwdnew'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "pwdnewverify",
      "name": "pwdnewverify",
      "data-vv-as": "pwdnew",
      "placeholder": "Verify New Password"
    },
    domProps: {
      "value": (_vm.pwd.newverify)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pwd, "newverify", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'pwdnewverify'
    }
  }, [_vm._v("Verify New Password")]), _vm._v(" "), (_vm.errors.has('pwdnewverify')) ? _c('div', {
    staticClass: "form-control-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('pwdnewverify')))]) : _vm._e()])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('button', {
    staticClass: "btn  btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPwd
    }
  }, [_vm._v("Reset")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#tab-orgs",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Organizations")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#tab-notificationtriggers",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Notification Triggers")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#tab-pwdreset",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Password Reset")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed99a032","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Profile.vue
// module id = 667
// module chunks = 1